/*
 * DEEP DIVES CONFIGURATION
 * This object contains the configuration information for all of our Deep Dive Tag Streams. These
 * are created as a way to build special stream packages for our deep dives, which
 * are normally just sent as a newsletter.
 *
 * TODO: Image handling should be changed so these image assets aren't included directly
 * in the site codebase. For some of the newer ones, I've started using uploader.axioscode.tools
 * to quickly upload the images without putting them directly in the code.
 *
 * TODO: This data should probably someday come from an API and there should be
 * a route on the site for axios.com/deep-dive/[slug] or something like that.
 */

export default [
  {
    name: "China",
    slug: "deep-dive-china",
    title: "A special report on China’s grab for power",
    image:
      "https://graphics.axios.com/illustrations/2018-05-26-china-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-05-26-china-social.jpg",
    issuesModuleConfig: [
      {
        name: "China",
        tagSlug: "china",
        backgroundColor: "#de2910",
      },
      {
        name: "Belt and Road Initiative",
        tagSlug: "one-belt-one-road-initiative",
        backgroundColor: "#ffde00",
      },
      {
        name: "Xi Jinping",
        tagSlug: "xi-jinping",
        backgroundColor: "#322fba",
      },
      {
        name: "China's economy",
        tagSlug: "china-economy",
        backgroundColor: "#197602",
      },
    ],
  },
  {
    name: "Robot Revolution",
    slug: "deep-dive-robot-revolution",
    title: "A special report on the revolution changing our lives",
    image:
      "https://graphics.axios.com/illustrations/2018-06-02-robot-revolution-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-06-02-robot-revolution-social.jpg",
    issuesModuleConfig: [
      {
        name: "Robots",
        tagSlug: "robots",
        backgroundColor: "#7385fa",
      },
      {
        name: "Artificial intelligence",
        tagSlug: "artificial-intelligence",
        backgroundColor: "#c69e4d",
      },
      {
        name: "Automation",
        tagSlug: "automation",
        backgroundColor: "#c36958",
      },
      {
        name: "Jobs",
        tagSlug: "jobs",
        backgroundColor: "#58c39a",
      },
    ],
  },

  {
    name: "Trade Wars",
    slug: "deep-dive-trade-wars",
    title: "A special report on a new era of global trade wars",
    image:
      "https://graphics.axios.com/illustrations/2018-06-09-trade-wars-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-06-09-trade-wars-social.jpg",
    issuesModuleConfig: [
      {
        name: "International trade",
        tagSlug: "international-trade",
        backgroundColor: "#ff1435",
      },
      {
        name: "Free trade",
        tagSlug: "free-trade",
        backgroundColor: "#4b07b0",
      },
      {
        name: "Trump's trade war",
        tagSlug: "trump-trade-war",
        backgroundColor: "#182aa2",
      },
      {
        name: "Global politics",
        tagSlug: "global-politics",
        backgroundColor: "#63e330",
      },
    ],
  },

  {
    name: "Health Care",
    slug: "deep-dive-health-care",
    title: "A special report on the next health care wars",
    image:
      "https://graphics.axios.com/illustrations/2018-06-16-health-care-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-06-16-health-care-social.jpg",
    issuesModuleConfig: [
      {
        name: "Health care",
        tagSlug: "health-care",
        backgroundColor: "#8800ff",
      },
      {
        name: "Affordable Care Act",
        tagSlug: "affordable-care-act",
        backgroundColor: "#03d7fd",
      },
      {
        name: "Medicare for All",
        tagSlug: "medicare-for-all",
        backgroundColor: "#ff3cac",
      },
      {
        name: "Health care costs",
        tagSlug: "health-care-costs",
        backgroundColor: "#00ff59",
      },
    ],
  },

  {
    name: "Climate change",
    slug: "deep-dive-climate-change",
    title: "A special report on the impact of global warming",
    image:
      "https://graphics.axios.com/illustrations/2018-06-23-climate-change-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-06-23-climate-change-social.jpg",
    issuesModuleConfig: [
      {
        name: "Climate change",
        tagSlug: "climate-change",
        backgroundColor: "#67bf6e",
      },
      {
        name: "Global warming",
        tagSlug: "global-warming",
        backgroundColor: "#f68582",
      },
      {
        name: "Extreme weather",
        tagSlug: "extreme-weather",
        backgroundColor: "#6552bc",
      },
      {
        name: "Energy",
        tagSlug: "energy",
        backgroundColor: "#50d4f5",
      },
    ],
  },

  {
    name: "An Aging World",
    slug: "deep-dive-population-shifts",
    title: "A special report on colossal demographic shifts around the world",
    image:
      "https://graphics.axios.com/illustrations/2018-07-21-population-shifts-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-07-21-population-shifts-social.png",
    issuesModuleConfig: [
      {
        name: "Demographics",
        tagSlug: "demography",
        backgroundColor: "#f97a5c",
      },
      {
        name: "Immigration",
        tagSlug: "immigration",
        backgroundColor: "#8368e3",
      },
      {
        name: "Population",
        tagSlug: "population",
        backgroundColor: "#ff8f44",
      },
      {
        name: "Future of work",
        tagSlug: "future-of-work",
        backgroundColor: "#129ee5",
      },
    ],
  },

  {
    name: "Financial Crisis",
    slug: "deep-dive-financial-crisis",
    title: "A special report on the 2008 financial crisis, a decade later",
    image:
      "https://graphics.axios.com/illustrations/2018-09-15-financial-crisis-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-09-15-financial-crisis-social.jpg",
    issuesModuleConfig: [
      {
        name: "Economy",
        tagSlug: "economy",
        backgroundColor: "#ffb8b8",
      },
      {
        name: "Stock market",
        tagSlug: "stock-market",
        backgroundColor: "#acdfff",
      },
      {
        name: "Banks",
        tagSlug: "banks",
        backgroundColor: "#ba90f1",
      },
      {
        name: "Wall Street",
        tagSlug: "wall-street",
        backgroundColor: "#f9d550",
      },
    ],
  },

  {
    name: "5G",
    slug: "deep-dive-5g",
    title: "A special report on the next generation of mobile networks",
    image: "https://graphics.axios.com/illustrations/2018-09-22-5g-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-09-22-5g-social.jpg",
    issuesModuleConfig: [
      {
        name: "5G",
        tagSlug: "5g",
        backgroundColor: "#0092d7",
      },
      {
        name: "Smart cities",
        tagSlug: "smart-cities",
        backgroundColor: "#e02717",
      },
      {
        name: "Wireless networks",
        tagSlug: "wireless-networks",
        backgroundColor: "#083283",
      },
      {
        name: "Mobile devices",
        tagSlug: "mobile-devices",
        backgroundColor: "#ea5c16",
      },
    ],
  },

  {
    name: "Space",
    slug: "deep-dive-space-race",
    title: "A special report on the forces shaping space",
    image:
      "https://graphics.axios.com/illustrations/2018-10-06-space-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-10-06-space-social.jpg",
    issuesModuleConfig: [
      {
        name: "Space",
        tagSlug: "space",
        backgroundColor: "#ec5d7b",
      },
      {
        name: "NASA",
        tagSlug: "nasa",
        backgroundColor: "#1dd2dd",
      },
      {
        name: "SpaceX",
        tagSlug: "spacex",
        backgroundColor: "#515fa6",
      },
      {
        name: "Rockets",
        tagSlug: "rockets",
        backgroundColor: "#deae83",
      },
    ],
  },

  {
    name: "Autonomous Vehicles",
    slug: "deep-dive-autonomous-vehicles",
    title: "A special report on the road to driverless cars",
    image:
      "https://graphics.axios.com/illustrations/2018-10-27-autonomous-vehicles-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-10-27-autonomous-vehicles-social.jpg",
    issuesModuleConfig: [
      {
        name: "Autonomous vehicles",
        tagSlug: "autonomous-vehicles",
        backgroundColor: "#000dff",
      },
      {
        name: "Tesla",
        tagSlug: "tesla",
        backgroundColor: "#1cff77",
      },
      {
        name: "Artificial intelligence",
        tagSlug: "artificial-intelligence",
        backgroundColor: "#ff2f59",
      },
      {
        name: "Self-driving cars",
        tagSlug: "self-driving-cars",
        backgroundColor: "#fff700",
      },
    ],
  },

  {
    name: "Drug Pricing",
    slug: "deep-dive-drug-pricing",
    title: "A special report on the thorny issue of drug prices",
    image:
      "https://graphics.axios.com/illustrations/2018-11-17-drug-pricing-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-11-17-drug-pricing-social.jpg",
    issuesModuleConfig: [
      {
        name: "Drugs",
        tagSlug: "drugs",
        backgroundColor: "#ecb938",
      },
      {
        name: "Drug prices",
        tagSlug: "drug-prices",
        backgroundColor: "#085ed1",
      },
      {
        name: "Health care",
        tagSlug: "health-care",
        backgroundColor: "#ea764b",
      },
      {
        name: "Pharmaceutical industry",
        tagSlug: "pharmaceutical-industry",
        backgroundColor: "#9fdcfe",
      },
    ],
  },
  {
    name: "Digital Divide",
    slug: "deep-dive-digital-divide",
    title: "A special report on the emerging forms of digital inequality",
    image:
      "https://graphics.axios.com/illustrations/2018-12-01-digital-divide-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2018-12-01-digital-divide-social.jpg",
    issuesModuleConfig: [
      {
        name: "Broadband",
        tagSlug: "broadband",
        backgroundColor: "#ff8b00",
      },
      {
        name: "Privacy",
        tagSlug: "privacy",
        backgroundColor: "#006afe",
      },
      {
        name: "Economic inequality",
        tagSlug: "economic-inequality",
        backgroundColor: "#ff487e",
      },
      {
        name: "Internet",
        tagSlug: "internet",
        backgroundColor: "#fec200",
      },
    ],
  },
  {
    name: "Refugee Crisis",
    slug: "deep-dive-refugee-crisis",
    title: "The refugee crisis is the worst it's been since WWII",
    image: require("assets/img/refugee-crisis.png"),
    ogImage: require("assets/img/refugee-crisis-social.jpg"),
  },
  {
    name: "Future of Retail",
    slug: "deep-dive-future-of-retail",
    title: "The battle to get shoppers out of the house",
    image: require("assets/img/retail-deep-dive.png"),
    ogImage: require("assets/img/retail-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "E-commerce",
        tagSlug: "e-commerce",
        backgroundColor: "#00abe9",
      },
      {
        name: "Shopping",
        tagSlug: "shopping",
        backgroundColor: "#d9318a",
      },
      {
        name: "Amazon",
        tagSlug: "amazon",
        backgroundColor: "#5ab279",
      },
      {
        name: "Walmart",
        tagSlug: "walmart",
        backgroundColor: "#5c4395",
      },
    ],
  },
  {
    name: "Davos",
    slug: "deep-dive-davos",
    title: "A new political and economic order is emerging",
    image: require("assets/img/davos-deep-dive.png"),
    ogImage: require("assets/img/davos-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Economy",
        tagSlug: "economy",
        backgroundColor: "#d9de47",
      },
      {
        name: "Geopolitics",
        tagSlug: "global-politics",
        backgroundColor: "#9dbbf2",
      },
      {
        name: "Inequality",
        tagSlug: "economic-inequality",
        backgroundColor: "#e64f1d",
      },
      {
        name: "Globalization",
        tagSlug: "tradeglobalization",
        backgroundColor: "#414141",
      },
    ],
  },
  {
    name: "Business of Sports",
    slug: "deep-dive-business-of-sports",
    title: "The evolution of sports consumption and fandom",
    image: require("assets/img/business-of-sports-deep-dive.png"),
    ogImage: require("assets/img/business-of-sports-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Esports",
        tagSlug: "esports",
        backgroundColor: "#a0dc29",
      },
      {
        name: "Sports Betting",
        tagSlug: "sports-betting",
        backgroundColor: "#ef5c66",
      },
      {
        name: "NFL",
        tagSlug: "national-football-league-nfl",
        backgroundColor: "#00d0e3",
      },
      {
        name: "Super Bowl",
        tagSlug: "super-bowl",
        backgroundColor: "#ff9300",
      },
    ],
  },
  {
    name: "Future of Dating",
    slug: "deep-dive-future-of-dating",
    title: "The gamification of courtship has gone global",
    image: require("assets/img/future-of-dating-deep-dive.png"),
    ogImage: require("assets/img/future-of-dating-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Dating apps",
        tagSlug: "dating-apps",
        backgroundColor: "#905cff",
      },
      {
        name: "Online privacy",
        tagSlug: "online-privacy",
        backgroundColor: "#0091ff",
      },
      {
        name: "Facebook",
        tagSlug: "facebook",
        backgroundColor: "#ff69fa",
      },
      {
        name: "Tinder",
        tagSlug: "tinder",
        backgroundColor: "#ff5b47",
      },
    ],
  },
  {
    name: "Data Privacy",
    slug: "deep-dive-data-privacy",
    title:
      "Personal data is our most valuable asset, but we've given it away to powerful corporations",
    image: require("assets/img/data-privacy-deep-dive.png"),
    ogImage: require("assets/img/data-privacy-deep-dive-social.png"),
    issuesModuleConfig: [
      {
        name: "Online Privacy",
        tagSlug: "online-privacy",
        backgroundColor: "#656565",
      },
      {
        name: "Personal data",
        tagSlug: "personal-data",
        backgroundColor: "#656565",
      },
      {
        name: "Facebook",
        tagSlug: "facebook",
        backgroundColor: "#656565",
      },
      {
        name: "Google",
        tagSlug: "google",
        backgroundColor: "#656565",
      },
    ],
  },
  {
    name: "Millennial Jobs",
    slug: "deep-dive-millennial-jobs",
    title:
      "Millennials are facing one of the toughest economic landscapes since WWII",
    image: require("assets/img/millennial-jobs-deep-dive.png"),
    ogImage: require("assets/img/millennial-jobs-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Automation",
        tagSlug: "automation",
        backgroundColor: "#b095ff",
      },
      {
        name: "Wages",
        tagSlug: "wages",
        backgroundColor: "#51abff",
      },
      {
        name: "Millennials",
        tagSlug: "millennials",
        backgroundColor: "#9cff75",
      },
      {
        name: "Jobs",
        tagSlug: "jobs",
        backgroundColor: "#ffa760",
      },
    ],
  },
  {
    name: "On-demand economy",
    slug: "deep-dive-on-demand-economy",
    title: "The on-demand economy is reshaping America's workforce",
    image:
      "https://graphics.axios.com/illustrations/2019-04-25-gig-economy-transparent.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-04-23-gig-economy-social.png",
    issuesModuleConfig: [
      {
        name: "Gig economy",
        tagSlug: "gig-economy",
        backgroundColor: "#e8bc19",
      },
      {
        name: "Future of work",
        tagSlug: "future-of-work",
        backgroundColor: "#6ba9c1",
      },
      {
        name: "Uber",
        tagSlug: "uber",
        backgroundColor: "#f43d14",
      },
      {
        name: "Automation",
        tagSlug: "automation",
        backgroundColor: "#589773",
      },
    ],
  },
  {
    name: "Neuroscience",
    slug: "deep-dive-neuroscience",
    title: "A special report on advances in understanding memory",
    image:
      "https://graphics.axios.com/illustrations/2019-05-18-neuroscience-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-05-18-neuroscience-social.jpg",
    issuesModuleConfig: [
      {
        name: "Neuroscience",
        tagSlug: "neuroscience",
        backgroundColor: "#4e9863",
      },
      {
        name: "Alzheimer's disease",
        tagSlug: "alzheimers-disease",
        backgroundColor: "#74c688",
      },
      {
        name: "Artificial intelligence",
        tagSlug: "artificial-intelligence",
        backgroundColor: "#8ed98c",
      },
      {
        name: "Deepfakes",
        tagSlug: "deepfakes",
        backgroundColor: "#9cf0a2",
      },
    ],
  },
  {
    name: "Global Threats",
    slug: "deep-dive-global-threats",
    title: "A special report on the greatest threats we face.",
    image:
      "https://graphics.axios.com/illustrations/2019-06-01-threats-transparent.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-01-threats-social.png",
    issuesModuleConfig: [
      {
        name: "Russia",
        tagSlug: "russia",
        backgroundColor: "#b82b1d",
      },
      {
        name: "China",
        tagSlug: "china",
        backgroundColor: "#000000",
      },
      {
        name: "Climate Change",
        tagSlug: "climate-change",
        backgroundColor: "#6c6c6c",
      },
      {
        name: "Cybersecurity",
        tagSlug: "cybersecurity",
        backgroundColor: "#dedede",
      },
    ],
  },
  {
    name: "Criminal Justice",
    slug: "deep-dive-criminal-justice",
    title: "A special report on the industry around U.S. incarceration",
    image:
      "https://graphics.axios.com/illustrations/2019-06-08-criminal-justice-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-08-criminal-justice-social.jpg",
    issuesModuleConfig: [
      {
        name: "Prisons",
        tagSlug: "prisons",
        backgroundColor: "#ea3528",
      },
      {
        name: "Prison Reform",
        tagSlug: "prison-reform",
        backgroundColor: "#99a1ab",
      },
      {
        name: "Criminal Justice",
        tagSlug: "criminal-justice",
        backgroundColor: "#24a427",
      },
      {
        name: "Poverty",
        tagSlug: "poverty",
        backgroundColor: "#232323",
      },
    ],
  },
  {
    name: "Plastics",
    slug: "deep-dive-plastics",
    title: "A special report on the global plastics problem",
    image:
      "https://graphics.axios.com/illustrations/2019-06-15-plastics-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-15-plastics-social.jpg",
    issuesModuleConfig: [
      {
        name: "Pollution",
        tagSlug: "pollution",
        backgroundColor: "#0dba86",
      },
      {
        name: "Climate Change",
        tagSlug: "climate-change",
        backgroundColor: "#24f0b2",
      },
      {
        name: "Plastic",
        tagSlug: "plastic",
        backgroundColor: "#0d98ba",
      },
      {
        name: "Environment",
        tagSlug: "environment",
        backgroundColor: "#0d42ba",
      },
    ],
  },
  {
    name: "Marijuana",
    slug: "deep-dive-marijuana",
    title: "A special report on the growing marijuana industry",
    image:
      "https://graphics.axios.com/illustrations/2019-06-22-marijuana-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-22-marijuana-social.jpg",
    issuesModuleConfig: [
      {
        name: "Marijuana",
        tagSlug: "marijuana",
        backgroundColor: "#1cb204",
      },
      {
        name: "CBD",
        tagSlug: "cbd",
        backgroundColor: "#2112DD",
      },
      {
        name: "Venture capital",
        tagSlug: "venture-capital",
        backgroundColor: "#FF6C12",
      },
      {
        name: "Pharmaceutical industry",
        tagSlug: "pharmaceutical-industry",
        backgroundColor: "#7F3A0F",
      },
    ],
  },
  {
    name: "Smart Cities",
    slug: "deep-dive-smart-cities",
    title: "A special report on the development of smart cities",
    image:
      "https://graphics.axios.com/illustrations/2019-06-29-cities-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-29-cities-social.jpg",
    issuesModuleConfig: [
      {
        name: "Housing",
        tagSlug: "housing",
        backgroundColor: "#cc5532",
      },
      {
        name: "Smart cities",
        tagSlug: "smart-cities",
        backgroundColor: "#4c60ac",
      },
      {
        name: "Privacy",
        tagSlug: "privacy",
        backgroundColor: "#b74478",
      },
      {
        name: "5G",
        tagSlug: "5g",
        backgroundColor: "#538871",
      },
    ],
  },
  {
    name: "The Moon",
    slug: "deep-dive-the-moon",
    title: "A special report on Earth's nearest neighbor",
    image:
      "https://graphics.axios.com/illustrations/2019-07-20-moon-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-07-20-moon-social.jpg",
    issuesModuleConfig: [
      {
        name: "Moon",
        tagSlug: "moon",
        backgroundColor: "#f53b3b",
      },
      {
        name: "Space",
        tagSlug: "space",
        backgroundColor: "#6aaedf",
      },
      {
        name: "NASA",
        tagSlug: "nasa",
        backgroundColor: "#eaca54",
      },
      {
        name: "Deep Dive - Space",
        tagSlug: "deep-dive-space-race",
        backgroundColor: "#22c26d",
      },
    ],
  },
  {
    name: "Future of Dying",
    slug: "deep-dive-future-of-dying",
    title: "A special report on the evolving conversation around death",
    image:
      "https://graphics.axios.com/illustrations/2019-08-09-future-of-dying-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-08-09-future-of-dying-social.png",
    issuesModuleConfig: [
      {
        name: "Deep Dive - Neuroscience",
        tagSlug: "deep-dive-neuroscience",
        backgroundColor: "#4e509b",
      },
      {
        name: "Deep Dive - Population shifts",
        tagSlug: "deep-dive-population-shifts",
        backgroundColor: "#a08abe",
      },
      {
        name: "Data privacy",
        tagSlug: "deep-dive-data-privacy",
        backgroundColor: "#7a9cb3",
      },
      {
        name: "Global threats",
        tagSlug: "deep-dive-global-threats",
        backgroundColor: "#4c4c4c",
      },
    ],
  },
];
